var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxManualBookOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86133 7.82936C9.86133 7.40946 9.98584 6.99899 10.2191 6.64986C10.4524 6.30071 10.784 6.02859 11.1719 5.8679C11.5599 5.70722 11.9867 5.66518 12.3986 5.74709C12.8104 5.82901 13.1887 6.03121 13.4856 6.32813C13.7826 6.62505 13.9848 7.00333 14.0667 7.41518C14.1486 7.82701 14.1065 8.25389 13.9459 8.64183C13.7852 9.02977 13.513 9.36134 13.1639 9.59463C12.8148 9.82791 12.4043 9.95243 11.9844 9.95243V10.6601",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9808 13.5795C11.7854 13.5795 11.627 13.4211 11.627 13.2257C11.627 13.0302 11.7854 12.8718 11.9808 12.8718",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9805 13.5795C12.1759 13.5795 12.3343 13.4211 12.3343 13.2257C12.3343 13.0302 12.1759 12.8718 11.9805 12.8718",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7684 21.1999H6.32229C5.75922 21.1999 5.2192 20.9763 4.82105 20.5782C4.42291 20.18 4.19922 19.6399 4.19922 19.0769C4.19922 18.5138 4.42291 17.9737 4.82105 17.5756C5.2192 17.1774 5.75922 16.9538 6.32229 16.9538H18.353C18.7284 16.9538 19.0884 16.8046 19.3538 16.5392C19.6192 16.2739 19.7684 15.9138 19.7684 15.5384V4.21542C19.7684 3.84004 19.6192 3.48004 19.3538 3.2146C19.0884 2.94917 18.7284 2.80005 18.353 2.80005H6.32229C5.76889 2.79985 5.23729 3.01574 4.84073 3.40173C4.44415 3.78773 4.21398 4.3133 4.19922 4.8665V19.0203",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3535 16.9539V21.2",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxManualBookOutline);
export default __webpack_public_path__ + "static/media/icon_24px_manual-book_outline.6ddb8f89f47eecd019bc33b70d5c7a3f.svg";
export { ForwardRef as ReactComponent };